import { useEffect, useRef } from "react";
import { pingAiCompetitorsEndpoints } from "../aiCompetitorsApi";

export const useAiCompetitorsWarmup = () => {
  const didWarmupRef = useRef(false);

  useEffect(() => {
    if (didWarmupRef.current) {
      return;
    }
    didWarmupRef.current = true;
    pingAiCompetitorsEndpoints();
  }, []);
};
